import React, { useEffect, useState } from 'react';
import { collection, getDocs, doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase';
import './UsuariosAdmin.css';

function UsuariosAdmin() {
  const [usuarios, setUsuarios] = useState([]);
  const [busca, setBusca] = useState('');
  const [uidSelecionado, setUidSelecionado] = useState(null);
  const [emailSelecionado, setEmailSelecionado] = useState('');
  const [estadoEspecialista, setEstadoEspecialista] = useState({
    raiz: false,
    snap: false,
    ranking: false
  });

  useEffect(() => {
    async function carregarUsuarios() {
      const snap = await getDocs(collection(db, 'usuarios'));
      const lista = snap.docs.map(doc => ({
        uid: doc.id,
        ...doc.data()
      }));
      setUsuarios(lista);
    }

    carregarUsuarios();
  }, []);

  const usuariosFiltrados = usuarios.filter((u) =>
    u.email?.toLowerCase().includes(busca.toLowerCase())
  );

  const selecionarUsuario = (uid, email) => {
    setUidSelecionado(uid);
    setEmailSelecionado(email);
    setEstadoEspecialista({
      raiz: false,
      snap: false,
      ranking: false
    });
  };

  const atualizarEspecialista = async () => {
    if (!uidSelecionado) return;

    const promessas = [];

    if (estadoEspecialista.raiz) {
      promessas.push(
        setDoc(doc(db, 'usuarios', uidSelecionado), { especialista: true }, { merge: true })
      );
    }

    if (estadoEspecialista.snap) {
      promessas.push(
        setDoc(doc(db, 'usuarios', uidSelecionado, 'snapDropdown2026', 'dados'), { especialista: true }, { merge: true })
      );
    }

    if (estadoEspecialista.ranking) {
      promessas.push(
        setDoc(doc(db, 'ranking', 'usuarios', uidSelecionado, 'pontos'), { especialista: true }, { merge: true })
      );
    }

    try {
      await Promise.all(promessas);
      alert('Especialista atualizado com sucesso!');
    } catch (erro) {
      console.error('Erro ao atualizar:', erro);
      alert('Erro ao atualizar especialista.');
    }
  };

  const removerEspecialista = async () => {
  if (!uidSelecionado) return;

  const promessas = [
    setDoc(doc(db, 'usuarios', uidSelecionado), { especialista: false }, { merge: true }),
    setDoc(doc(db, 'usuarios', uidSelecionado, 'snapDropdown2026', 'dados'), { especialista: false }, { merge: true }),
    setDoc(doc(db, 'ranking', 'usuarios', uidSelecionado, 'pontos'), { especialista: false }, { merge: true })
  ];

  try {
    await Promise.all(promessas);
    alert('Especialista removido com sucesso!');
  } catch (erro) {
    console.error('Erro ao remover:', erro);
    alert('Erro ao remover especialista.');
  }
};


  return (
    <div className="usuarios-admin-container">
      <h2>Gestão de Especialistas</h2>

      <input
        type="text"
        placeholder="Pesquisar por email..."
        value={busca}
        onChange={(e) => setBusca(e.target.value)}
        className="input-busca"
      />

      <ul className="lista-usuarios">
        {usuariosFiltrados.map((u) => (
          <li
            key={u.uid}
            className={uidSelecionado === u.uid ? 'selecionado' : ''}
            onClick={() => selecionarUsuario(u.uid, u.email)}
          >
            <strong>{u.email}</strong>
            <span className="uid">UID: {u.uid}</span>
          </li>
        ))}
      </ul>

      {uidSelecionado && (
        <div className="area-opcoes">
          <h3>Utilizador selecionado:</h3>
          <p><strong>Email:</strong> {emailSelecionado}</p>
          <p><strong>UID:</strong> {uidSelecionado}</p>

          <label>
            <input
              type="checkbox"
              checked={estadoEspecialista.raiz}
              onChange={(e) =>
                setEstadoEspecialista((prev) => ({ ...prev, raiz: e.target.checked }))
              }
            />
            Tornar especialista em <code>/usuarios/{uidSelecionado}</code>
          </label>

          <label>
            <input
              type="checkbox"
              checked={estadoEspecialista.snap}
              onChange={(e) =>
                setEstadoEspecialista((prev) => ({ ...prev, snap: e.target.checked }))
              }
            />
            Tornar especialista em <code>/usuarios/{uidSelecionado}/snapDropdown2026/dados</code>
          </label>

          <label>
            <input
              type="checkbox"
              checked={estadoEspecialista.ranking}
              onChange={(e) =>
                setEstadoEspecialista((prev) => ({ ...prev, ranking: e.target.checked }))
              }
            />
            Tornar especialista em <code>/ranking/usuarios/{uidSelecionado}/pontos</code>
          </label>

          <button className="botao-salvar" onClick={atualizarEspecialista}>
            Salvar alterações
          </button>

          <button className="botao-remover" onClick={removerEspecialista}>
            Remover especialista
            </button>
        </div>
      )}
    </div>
  );
}

export default UsuariosAdmin;